import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

@Injectable()
export class FilterState {

  private _venda: boolean = true;
  private _lloguer: boolean = true;
  private _nau: boolean = true;
  private _parcela: boolean = true;  

  constructor(public http: Http) { }

  set venda(venda) {
    this._venda = venda;
  }

  get venda(): boolean {
    return this._venda;
  }

  set lloguer(lloguer) {
    this._lloguer = lloguer;
  }

  get lloguer(): boolean {
    return this._lloguer;
  } 

  set nau(nau) {
    this._nau = nau;
  }

  get nau(): boolean {
    return this._nau;
  }     

  set parcela(parcela) {
    this._parcela = parcela;
  }

  get parcela(): boolean {
    return this._parcela;
  }

  getFiltre(): any {
    let _filtres = {
      regim: [],
      tipologia: []
    }

    this._venda ? _filtres.regim.push("Venda") : null;
    this._lloguer ? _filtres.regim.push("Lloguer") : null;
    this._nau ? _filtres.tipologia.push("Nau") : null;
    this._parcela ? _filtres.tipologia.push("Parcel·la") : null;

    return _filtres;
  }
}



// WEBPACK FOOTER //
// ./src/providers/filter_state.ts